import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import axios from "axios";
import JSZip from 'jszip';
import { arcgisToGeoJSON } from "@terraformer/arcgis";
import shpwrite from '@mapbox/shp-write';
import tokml from 'tokml';
import { showAlert } from '../../../../utils/Helpers';
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";

const excelZip = new JSZip();
const shpZip = new JSZip();
const kmzZip = new JSZip();

const getResult = (item, name, exportType, isDataSearch) => {

    const source = isDataSearch ? item : item[name];
    switch (exportType) {
        case 'excel': {
            const attributesArray = source.features.map(feature => feature.attributes);
            return { [name]: attributesArray };
        }
        case 'shp':
        case 'kmz':
            return { [name]: source };
        default:
            return null;
    }
}

const getDataForExport = (data, selected, exportAll, exportType, searchType) => {
    const uniqueSet = new Set();

    const exportData = data.flatMap(item => {
        if (searchType === 'map') {
            if (!exportAll) {
                if (Object.keys(item).includes(selected)) {
                    const name = selected;
                    const result = getResult(item, name, exportType);
                    return result ? [result] : [];
                }
                return [];
            } else {
                let name = Object.keys(item)[0];
                return getResult(item, name, exportType) ? [getResult(item, name, exportType)] : [];
            }
        } else {
            let name = selected;
            return getResult(item, name, exportType, true) ? [getResult(item, name, exportType, true)] : [];
        }
    })
        .filter(item => {
            const stringified = JSON.stringify(item);
            if (uniqueSet.has(stringified)) {
                return false; // Skip duplicates
            }
            uniqueSet.add(stringified);
            return true;
        });

    return exportData;
}
// const getDataForExport = (data, selected, exportAll, exportType, searchType) => {
//     var exportData = data.flatMap(item => {
//         if (searchType === 'map') {
//             if (!exportAll) {
//                 if (Object.keys(item).includes(selected)) {
//                     const name = selected;
//                     return getResult(item, name, exportType);
//                 }
//                 return null;
//             }
//             else {
//                 let name = Object.keys(item)[0];
//                 return getResult(item, name, exportType);
//             }
//         } else {
//             let name = selected;
//             return getResult(item, name, exportType, true);
//         }
//     }).filter(item => item !== null);
//     return exportData;
// }

const downloadFile = (buffer, type, filename) => {
    const blob = new Blob([buffer], { type });
    saveAs(blob, filename);
};

const convertGeoJSONToShapefile = (geojson, filename) => {
    if (geojson != undefined && geojson.features && geojson.features.length > 0) {
        shpwrite.download(geojson, {
            filename: `${filename}`,
            outputType: 'blob',
            types: {
                point: `${filename}`,
                polygon: `${filename}`,
                polyline: `${filename}`,
            },
        });
    }
};

const convertGeoJSONToKMZ = (geojson, filename) => {
    const kml = tokml(geojson);
    const zip = new JSZip();
    zip.file(`${filename}.kml`, kml);

    zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, `${filename}.kmz`);
    });
};

export const GenerateExcel = (data, selected, exportAll, searchType, t, i18n, onComplete) => {
    // const {il8n}= useTranslation();
    const createXLSX = (data) => {
        const ws = XLSX.utils.json_to_sheet(data);
        return ws;
    };
    var generatedFiles = [];
    const getFilename = (baseName) => {
        return `${baseName}`;
    };

    if (data) {
        if (selected === 'Permit') {

            const ws = createXLSX(data);
            const wb = XLSX.utils.book_new();

            const getUniqueSheetName = (name, existingNames) => {
                let newName = name;
                let counter = 1;

                // Keep appending a number until a unique name is found
                while (existingNames.includes(newName)) {
                    newName = `${name} (${counter})`;
                    counter++;
                }

                return newName;
            };

            const existingSheetNames = [];

            // Iterate over sheets and append each data to a new sheet in the workbook
            data.forEach((sheet) => {
                const uniqueSheetName = getUniqueSheetName(
                    sheet.name,
                    existingSheetNames
                );

                // Add the unique sheet name to the list of existing sheet names
                existingSheetNames.push(uniqueSheetName);

                const ws = XLSX.utils.json_to_sheet(sheet.data); // Create a sheet from the data
                XLSX.utils.book_append_sheet(wb, ws, uniqueSheetName); // Append the sheet to the workbook
            });

            // Write the workbook to an Excel buffer
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

            // Create a Blob from the buffer
            const blob = new Blob([excelBuffer], {
                type: "application/octet-stream",
            });

            // Trigger the download
            saveAs(blob, `${selected}.xlsx`);

        }
        else if (selected !== 'null' && data.length > 0) {
            const exportData = getDataForExport(data, selected, exportAll, 'excel', searchType);

            exportData.map((obj) => {
                Object.entries(obj).forEach(async ([layerName, layerFeatures]) => {
                    const normalizedFeatures = normalizeRows(layerFeatures);
                    const sheetname = layerName.length > 30 ? layerName.substring(0, 27) + "..." : layerName;
                    //const ws = createXLSX(layerFeatures);
                    const ws = createXLSX(normalizedFeatures); 

                    const wb = {
                        SheetNames: [sheetname],
                        Sheets: {
                            [sheetname]: ws,
                        },
                    };

                    const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
                    const buf = new ArrayBuffer(wbout.length);
                    const view = new Uint8Array(buf);
                    const byteArray = Array.from(wbout, char => char.charCodeAt(0) & 0xFF);
                    view.set(byteArray);
                    const filename = `${getFilename(sheetname)}.xlsx`;

                    const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    generatedFiles.push({ blob, filename });

                    if (exportAll) {
                        excelZip.file(filename, buf);
                    } else {
                        downloadFile(buf, 'application/vnd.ms-excel', filename);
                    }
                });

            });
            if (onComplete) {
                onComplete(); // Notify the caller that the export is complete
            }

            return generatedFiles

        }
        // New condition: selected === 'custom'

        else {
            let modifiedData = '';
            let fileName = ''
            if (i18n.language === "en") {
                // Modify the data to match the new key names
                modifiedData = data.map(item => ({
                    "Schema Name": item.name,
                    "Description": item.description,
                    "Summary": item.summary,
                    "Use Limitations": item.useLimitations,
                    "Credits": item.credits,
                    "West": item.west,
                    "East": item.east,
                    "North": item.north,
                    "South": item.south,
                    "Organization": item.organization,
                    "Created Date": (new Date(item.createdDate)).toLocaleString(),
                    "Updated Date": (new Date(item.updatedDate)).toLocaleString(),
                    "Source": item.source,
                    "Licence": item.licence

                }));


            } else {
                // Modify the data to match the new key names
                modifiedData = data.map(item => ({
                    "Schema Name": item.name_ar,
                    "Description": item.description_ar,
                    "Summary": item.summaryAr,
                    "Use Limitations": item.useLimitationsAr,
                    "Credits": item.creditsAr,
                    "West": item.westAr,
                    "East": item.eastAr,
                    "North": item.northAr,
                    "South": item.southAr,
                    "Organization": item.organizationAr,
                    "Created Date": (new Date(item.createdDate)).toLocaleString("en-GB"),
                    "Updated Date": (new Date(item.updatedDate)).toLocaleString("en-GB"),
                    "Source": item.sourceAr,
                    "Licence": item.licenceAr

                }));

            }

            // Convert the modified data to a worksheet
            const worksheet = XLSX.utils.json_to_sheet(modifiedData);

            // Create a workbook and append the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "MetadataDetails");

            // Generate a buffer and write the file
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
            fileName = data[0].name + ".xlsx";
            // Use FileSaver to save the file
            saveAs(blob, fileName);



        }

    }
};

const normalizeDates = (features) => {
    return features.map(row => ({
        ...row,
        ObservationDate: row.ObservationDate
            ? new Date(Number(row.ObservationDate))
            : null
    }));
};

const normalizeRows = (rows) => {
    return rows.map(row => {
        const newRow = {};
        Object.entries(row).forEach(([key, value]) => {
            newRow[key] = formatExcelValue(value);
        });
        return newRow;
    });
};

const formatExcelValue = (value) => {

    if (value === null || value === undefined) return value;
    
    // 1️⃣ Decimal numbers → fixed precision
    if (typeof value === "number" && !Number.isInteger(value)) {
        return Number(value.toFixed(2));
    }

    // 2️⃣ Timestamp detection (milliseconds OR seconds)
    if (typeof value === "number") {
        const absVal = Math.abs(value);

        // Milliseconds timestamp (>= 2001-09-09)
        if (absVal >= 1000000000000 && absVal <= 9999999999999) {
            const date = new Date(value);
            if (!isNaN(date)) return date;
        }

        // Seconds timestamp
        if (absVal >= 1000000000 && absVal < 1000000000000) {
            const date = new Date(value * 1000);
            if (!isNaN(date)) return date;
        }
    }

    // 3️⃣ ISO / date string
    if (typeof value === "string" && !isNaN(Date.parse(value))) {
        return new Date(value);
    }

    // 4️⃣ Fallback
    return value;
};




//Function - Before adding worker process - issue(scrren freeze when click on any export btn)
// export const GenerateShapefile = (data, selected, exportAll, searchType,t) => {
//     const exportData = getDataForExport(data, selected, exportAll, 'shp', searchType);
//     let promises = [];
//     exportData.map((obj) => {
//         Object.entries(obj).forEach(([layerName, layerResults]) => {
//             const geojson =  arcgisToGeoJSON(layerResults);
//             const filename = `${layerName}`;

//             if (exportAll) {
//                 const data = geojson.features;
//                 const geometryType = layerResults.geometryType.toUpperCase();
//                 const geometries = geojson.features.map((feature) => feature.geometry.coordinates);

//                 shpwrite.write(data, geometryType, geometries, function (err, files) {
//                     if (err) {
//                         console.error('Error writing Shapefile:', err);
//                     } else {

//                         promises.push(shpZip.file(`${filename}.shp`, files.shp.buffer));
//                         promises.push(shpZip.file(`${filename}.shx`, files.shx.buffer));
//                         promises.push(shpZip.file(`${filename}.dbf`, files.dbf.buffer));
//                         promises.push(shpZip.file(`${filename}.prj`, files.prj));

//                         // Add the .cpg file for UTF-8 encoding
//                         promises.push(shpZip.file(`${filename}.cpg`, "UTF-8"));
//                     }
//                 });

//             } else {
//                 convertGeoJSONToShapefile(geojson, filename); 
//             }
//         });
//     });
//     if (exportAll) {
//         Promise.all(promises).then(() => {
//             shpZip
//                 .generateAsync({
//                     type: "blob"
//                 })
//                 .then(content => {
//                     saveAs(content, "ExportShapefile.zip");  
//                     // showAlert(t('dataExportSuccess'), "success");
//                 }).catch((err) => {
//                     console.log(`error in shp zip export`, err);                    
//                     throw new Error(err);
//                 });
//         }).catch((er) => {
//             console.log('error in shp export', er);           
//             throw new Error(er);
//         })

//     }
// }

function convertGeoJSONToFeatureCollection(geojson) {
    return {
        "layers": [
            {
                "featureSet": {
                    "features": geojson[0].features.map(feature => ({
                        "geometry": feature.geometry,
                        "attributes": feature.properties
                    })),
                    "geometryType": "esriGeometryPoint" // Change based on geometry type
                }
            }
        ]
    };
}

const getEsriGeometryType = (geoType) => {
    switch (geoType) {
        case "Point": return "esriGeometryPoint";
        case "MultiPoint": return "esriGeometryMultipoint";
        case "LineString":
        case "MultiLineString": return "esriGeometryPolyline";
        case "Polygon":
        case "MultiPolygon": return "esriGeometryPolygon";
        default: return "esriGeometryUnknown";
    }
};

// Function to map GeoJSON field types to Esri field types
const getEsriFieldType = (type) => {
    switch (type) {
        case "integer": return "esriFieldTypeInteger";
        case "small-integer": return "esriFieldTypeSmallInteger";
        case "double": return "esriFieldTypeDouble";
        case "float": return "esriFieldTypeDouble";
        case "string": return "esriFieldTypeString";
        case "date": return "esriFieldTypeDate";
        default: return "esriFieldTypeString"; // Default to string if unknown
    }
};
export const GenerateGeoJSON = (data, selected, exportAll, searchType, t) => {
    return new Promise((resolve, reject) => {
        const exportData = getDataForExport(data, selected, exportAll, "shp", searchType);
        let promises = [];
        exportData.map((obj) => {
            for (const [layerName, layerResults] of Object.entries(obj)) {
                if (!layerResults || !layerResults.features || layerResults.features.length === 0) {
                    console.warn(`Skipping layer "${layerName}" due to missing or empty features.`);
                    continue;
                }
                const worker = new Worker(new URL("./geoJsonWorker.js", import.meta.url), { type: "module" });
                const workerPromise = new Promise(async (resolveWorker, rejectWorker) => {
                    worker.onmessage = (e) => {
                        if (e.data.success) {
                            const geojson = e.data.geojson;
                            console.log(`Worker processed GeoJSON for layer "${layerName}":`, geojson);
                            // Build fieldAliases dynamically
                            const esriGeometryType = getEsriGeometryType(geojson.features[0]?.geometry?.type);
                            let fieldAliases = {};
                            let fields = [];
                            if (layerResults.fields) {
                                layerResults.fields.forEach(field => {
                                    const fieldType = getEsriFieldType(field.type);
                                    fieldAliases[field.name] = field.alias;  // Create fieldAliases object
                                    fields.push({
                                        "name": field.name,
                                        "type": fieldType,
                                        "alias": field.alias,
                                        ...(field.length ? { "length": field.length } : {}) // Add length only if it exists
                                    });
                                });
                            }
                            // Format the output as per the required Esri JSON structure
                            const esriJson = {
                                "displayFieldName": "",
                                "LayerName": layerName.replace(/[^a-zA-Z0-9]/g, ''),
                                "fieldAliases": fieldAliases,
                                "geometryType": esriGeometryType,
                                "spatialReference": layerResults.spatialReference,
                                "fields": fields,
                                "features": geojson.features.map(feature => ({
                                    "attributes": feature.properties,
                                    "geometry": esriGeometryType === "esriGeometryPoint"
                                        ? { "x": feature.geometry.coordinates[0], "y": feature.geometry.coordinates[1] }
                                        : esriGeometryType === "esriGeometryPolyline"
                                            ? { "paths": feature.geometry.coordinates }
                                            : esriGeometryType === "esriGeometryPolygon"
                                                ? { "rings": feature.geometry.coordinates }
                                                : {}
                                }))
                            };
                            resolveWorker(esriJson);
                        } else {
                            console.error("Error in worker:", e.data.error);
                            rejectWorker(e.data.error);
                        }
                        worker.terminate();
                    };
                    worker.onerror = (error) => {
                        console.error("Worker error:", error);
                        rejectWorker(error);
                        worker.terminate();
                    };
                    console.log(`Sending layerResults to worker for layer "${layerName}":`, layerResults);
                    var filteredFeatures = await getFeaturesByFilter(layerResults.features);
                    worker.postMessage(filteredFeatures);
                });
                promises.push(workerPromise);
            }
        });
        Promise.all(promises)
            .then((geojsonData) => resolve(geojsonData))
            .catch(error => reject(error));
    });
};

export const GenerateGDBfile = async (data, selected, exportAll, searchType, t, onComplete, gpServiceURL) => {
    try {
        // Generate GeoJSON data
        const geojsonData = await GenerateGeoJSON(data, selected, exportAll, searchType, t);
        console.log("Generated GeoJSON:", geojsonData);

        // Parameters for GP service
        const params = {
            "geoJSON": JSON.stringify(geojsonData)
            //"Renderer": JSON.stringify(renderer)
        };
        // ArcGIS GP Service URL 
        const gpServiceUrl = gpServiceURL;
        // Submit GP job
        geoprocessor.submitJob(gpServiceUrl, params).then((jobInfo) => {
            const jobId = jobInfo.jobId;
            console.log("Job Submitted:", jobId);
            const options = {
                interval: 1500,
                statusCallback: (status) => {
                    console.log("Job Status:", status.jobStatus);
                }
            };
            // Wait for job completion
            jobInfo.waitForJobCompletion(options).then(() => {
                jobInfo.fetchResultData("Output").then(function (
                    results
                ) {

                    window.open(results.value, "_self");
                    if (onComplete) onComplete(geojsonData);
                    console.log("completed")
                })
            });
        }).catch((error) => {
            console.error("Error submitting GP job:", error);
            if (onComplete) onComplete();
        });
        // Callback if needed
    } catch (error) {
        console.error("Error generating GeoJSON:", error);
        if (onComplete) onComplete();
    }
};


export const GenerateShapefile = (data, selected, exportAll, searchType, t, onComplete) => {
    const exportData = getDataForExport(data, selected, exportAll, "shp", searchType);
    let promises = [];

    exportData.map((obj) => {
        for (const [layerName, layerResults] of Object.entries(obj)) {
            if (!layerResults || !layerResults.features || layerResults.features.length === 0) {
                console.warn(`Skipping layer "${layerName}" due to missing or empty features.`);
                continue;
            }

            const worker = new Worker(new URL("./geoJsonWorker.js", import.meta.url), { type: "module" });

            const workerPromise = new Promise(async (resolve, reject) => {
                worker.onmessage = (e) => {
                    if (e.data.success) {
                        const geojson = e.data.geojson;
                        console.log(`Worker processed GeoJSON for layer "${layerName}":`, geojson);

                        if (exportAll) {
                            const data = geojson;
                            const geometryType = layerResults.geometryType.toUpperCase();
                            const geometries = geojson.map(feature => feature.geometry.coordinates);

                            shpwrite.write(data, geometryType, geometries, function (err, files) {
                                if (err) {
                                    console.error("Error writing Shapefile:", err);
                                    reject(err);
                                } else {
                                    promises.push(shpZip.file(`${layerName}.shp`, files.shp.buffer));
                                    promises.push(shpZip.file(`${layerName}.shx`, files.shx.buffer));
                                    promises.push(shpZip.file(`${layerName}.dbf`, files.dbf.buffer));
                                    promises.push(shpZip.file(`${layerName}.prj`, files.prj));
                                    promises.push(shpZip.file(`${layerName}.cpg`, "UTF-8"));
                                    resolve();
                                }
                            });
                        } else {
                            convertGeoJSONToShapefile(geojson, layerName);
                            resolve();
                        }
                    } else {
                        console.error("Error in worker:", e.data.error);
                        reject(e.data.error);
                    }
                    worker.terminate();
                };

                worker.onerror = (error) => {
                    console.error("Worker error:", error);
                    reject(error);
                    worker.terminate();
                };

                // Send layerResults to worker for processing
                console.log(`Sending layerResults to worker for layer "${layerName}":`, layerResults);
                var filteredFeatures = await getFeaturesByFilter(layerResults.features)
                worker.postMessage(filteredFeatures);
            });

            promises.push(workerPromise);
        }
    })

    Promise.all(promises)
        .then(() => {
            if (exportAll) {
                shpZip
                    .generateAsync({ type: "blob" })
                    .then(content => {
                        saveAs(content, "ExportShapefile.zip");
                        if (onComplete) onComplete();
                    })
                    .catch(err => {
                        console.error("Error in shp zip export:", err);
                        if (onComplete) onComplete();
                        throw new Error(err);
                    });
            } else {
                if (onComplete) onComplete();
            }
        })
        .catch(er => {
            console.error("Error in shp export:", er);
            if (onComplete) onComplete();
            throw new Error(er);
        });

};



//Function - Before adding worker process - issue(scrren freeze when click on any export btn)
// export const GenerateKMZ = (data, selected, exportAll, searchType, t) => {
//     const exportData = getDataForExport(data, selected, exportAll, 'kmz', searchType);
//     let promises = [];
//     exportData.map((obj) => {
//         Object.entries(obj).forEach(([layerName, layerResults]) => {
//             const geojson = arcgisToGeoJSON(layerResults);
//             const filename = `${layerName}`;
//             const kml = tokml(geojson);
//             const zip = new JSZip();
//             zip.file(`${filename}.kml`, kml);

//             if (exportAll) {
//                 promises.push(
//                     zip.generateAsync({ type: 'blob' }).then((content) => {
//                         kmzZip.file(`${filename}.kmz`, content);
//                     })
//                 );
//             } else {

//                 zip.generateAsync({ type: 'blob' }).then((content) => {
//                     // Save the KMZ file
//                     saveAs(content, `${filename}.kmz`);
//                 });
//             }
//         });
//     });
//     if (exportAll) {
//         Promise.all(promises).then(() => {
//             kmzZip
//                 .generateAsync({
//                     type: "blob"
//                 })
//                 .then(content => {
//                     saveAs(content, "ExportKMZ.zip");
//                     showAlert(t('dataExportSuccess'), "success");
//                 }).catch((err) => {
//                     console.log(`error in kmz zip export`, err);
//                     throw new Error(err);
//                 });
//         }).catch((err) => {
//             console.log(`error in kmz export`, err);
//             throw new Error(err);
//         });

//     }
// }
export const getFeaturesByFilter = (features) => {
    // return features.map((feature) => ({
    //     geometry: JSON.parse(JSON.stringify(feature.geometry)), // Deep copy geometry
    //     attributes: feature.attributes ? { ...feature.attributes } : {} // Copy attributes
    // }));
    return features
        .filter(feature => feature.geometry && feature.geometry.spatialReference)
        .map(feature => ({
            geometry: JSON.parse(JSON.stringify(feature.geometry)),
            attributes: feature.attributes ? { ...feature.attributes } : {}
        }));
};
export const GenerateKMZ = (data, selected, exportAll, searchType, t, onComplete) => {
    const exportData = getDataForExport(data, selected, exportAll, "kmz", searchType);
    let promises = [];

    exportData.map((obj) => {
        Object.entries(obj).forEach(([layerName, layerResults]) => {
            if (!layerResults || !layerResults.features || layerResults.features.length === 0) {
                console.warn(`Skipping layer "${layerName}" due to missing or empty features.`);
                return;
            }

            const worker = new Worker(new URL("./geoJsonWorker.js", import.meta.url), { type: "module" });

            const workerPromise = new Promise(async (resolve, reject) => {
                worker.onmessage = (e) => {
                    if (e.data.success) {
                        const geojson = e.data.geojson;
                        console.log(`Worker processed GeoJSON for layer "${layerName}":`, geojson);

                        const filename = `${layerName}`;
                        const kml = tokml(geojson);
                        const zip = new JSZip();
                        zip.file(`${filename}.kml`, kml);

                        if (exportAll) {
                            zip.generateAsync({ type: "blob" }).then((content) => {
                                kmzZip.file(`${filename}.kmz`, content);
                                resolve();
                            }).catch((err) => {
                                console.error("Error generating KMZ:", err);
                                reject(err);
                            });
                        } else {
                            zip.generateAsync({ type: "blob" }).then((content) => {
                                saveAs(content, `${filename}.kmz`);
                                resolve();
                            }).catch((err) => {
                                console.error("Error saving KMZ:", err);
                                reject(err);
                            });
                        }
                    } else {
                        console.error("Error in worker:", e.data.error);
                        reject(e.data.error);
                    }
                    worker.terminate();
                };

                worker.onerror = (error) => {
                    console.error("Worker error:", error);
                    reject(error);
                    worker.terminate();
                };

                // Send layerResults to worker for GeoJSON conversion
                console.log(`Sending layerResults to worker for layer "${layerName}":`, layerResults);
                var filteredFeatures = await getFeaturesByFilter(layerResults.features);
                worker.postMessage(filteredFeatures);
            });

            promises.push(workerPromise);
        });
    });


    Promise.all(promises)
        .then(() => {
            if (exportAll) {
                kmzZip
                    .generateAsync({ type: "blob" })
                    .then(content => {
                        saveAs(content, "ExportKMZ.zip");
                        showAlert(t("dataExportSuccess"), "success");
                        if (onComplete) onComplete();
                    })
                    .catch(err => {
                        console.error("Error in KMZ zip export:", err);
                        if (onComplete) onComplete();
                        throw new Error(err);
                    });
            } else {
                if (onComplete) onComplete();
            }
        })
        .catch(err => {
            console.error("Error in KMZ export:", err);
            if (onComplete) onComplete();
            throw new Error(err);
        });
};

export const convertToShapefile = (features, filename, callback) => {
    if (!features || !Array.isArray(features) || features.length === 0) {
        console.error("Invalid features array provided.");
        return;
    }

    // Flatten the features in case of nested arrays
    const allFeatures = features.flat();

    try {
        const geojson = { type: "FeatureCollection", features: allFeatures };

        const geometries = allFeatures.map(feature => feature.geometry.coordinates);
        const propertiesOnly = allFeatures.map(feature => feature.properties);

        if (!allFeatures[0]?.geometry?.type) {
            console.error("Invalid geometry type detected.");
            return;
        }

        shpwrite.write(propertiesOnly, allFeatures[0].geometry.type.toUpperCase(), geometries, async (err, files) => {
            if (err) {
                console.error("Error creating Shapefile:", err);
                return;
            }

            try {
                const zip = new JSZip();
                zip.file(`${filename}.shp`, files.shp.buffer);
                zip.file(`${filename}.shx`, files.shx.buffer);
                zip.file(`${filename}.dbf`, files.dbf.buffer);
                zip.file(`${filename}.prj`, files.prj);
                zip.file(`${filename}.cpg`, "UTF-8");

                const blob = await zip.generateAsync({ type: "blob" });
                callback(blob);
            } catch (zipError) {
                console.error("Error generating ZIP file:", zipError);
            }
        });

    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
